import type { TAccordionProps } from "@molecules/Accordion/types";

export const allAccordions: TAccordionProps[] = [
  {
    title: "⁠Quem pode se beneficiar da plataforma da Data Stone?",
    description:
      "Empresas de todos os portes que buscam dados precisos e atualizados para otimizar vendas, marketing e tomada de decisão. Desde startups até grandes corporações, qualquer negócio que queira melhorar a performance comercial pode aproveitar nossos recursos.",
  },
  {
    title: "Quais são os planos disponíveis e o que cada um oferece?",
    description:
      "Oferecemos planos flexíveis que variam de acordo com volume de dados, funcionalidades e suporte. Assim, você pode escolher desde um plano básico para pequenas equipes até opções avançadas com integrações e recursos premium.",
  },
  {
    title: "Quais são os módulos da plataforma e suas funcionalidades?",
    description:
      "A Data Stone conta com módulos para enriquecimento de dados, segmentação de leads, integração com sistemas externos, monitoramento de performance, e segurança avançada — tudo em uma interface simples e intuitiva.",
  },
  {
    title: "A plataforma é aderente à LGPD?",
    description: `Sim. Atuamos com responsabilidade legal e técnica em conformidade com a LGPD. Todos os dados são provenientes de fontes públicas ou legalmente acessíveis e são tratados com base em fundamentos como legítimo interesse e cumprimento de obrigação legal. Utilizamos logs de auditoria, controle de acesso por IP, gestão de consentimento quando aplicável e oferecemos documentação de compliance sob demanda.`,
  },
  {
    title: "Qual a acuracidade dos dados da plataforma?",
    description:
      "Trabalhamos com múltiplas fontes confiáveis e processos contínuos de validação, garantindo alta precisão e atualizações frequentes para manter suas informações sempre corretas.",
  },
  {
    title:
      "É possível integrar a plataforma a sistemas externos como CRMs ou ferramentas de automação?",
    description:
      "Sim. Nossa API e conectores prontos permitem integração rápida com CRMs, ERPs e plataformas de automação, garantindo que seus dados fluam automaticamente entre sistemas.",
  },
  {
    title: "Como funciona o consumo de créditos?",
    description:
      "Cada ação de consulta, enriquecimento ou exportação de dados consome créditos, de acordo com o tipo e volume de informações acessadas. Você pode acompanhar o consumo em tempo real no painel.",
  },
  {
    title: "Quais são as opções de suporte oferecidas?",
    description:
      "Disponibilizamos suporte via chat, e-mail e telefone, além de uma base de conhecimento completa. Planos avançados contam com atendimento prioritário e gerente de conta dedicado.",
  },
  {
    title:
      "A plataforma é segura para uso em ambientes corporativos exigentes?",
    description:
      "Sim. Contamos com criptografia de ponta, protocolos de segurança certificados e monitoramento constante, garantindo alta disponibilidade e proteção contra ameaças.",
  },
  {
    title: "Quais são os diferenciais da Data Stone em relação ao mercado?",
    description:
      "Nosso grande diferencial é a combinação de dados altamente precisos, facilidade de integração e suporte especializado, permitindo que você obtenha resultados rápidos e consistentes.",
  },
  {
    title: "Quais empresas já utilizam a Data Stone?",
    description:
      "Atendemos empresas de diversos segmentos como tecnologia, varejo, serviços financeiros e indústrias. Nossa base de clientes inclui tanto grandes marcas quanto negócios em crescimento.",
  },
  {
    title: "Como posso começar a utilizar?",
    description:
      "Basta entrar em contato com nossa equipe para solicitar uma demonstração ou criar sua conta. Em poucos passos, você terá acesso à plataforma e poderá começar a gerar resultados.",
  },
];
